/**
 * Информация по запросам карт
 */
export default class GeoMapRequestInfo {
  constructor() {
    this.max_validtime_request_count = 0;
    this.max_request_count_day = 0;
    this.current_request_count = 0;
    this.current_validtime_request_count = 0;
  }
}